import React from "react";

/**
 * One section header for every page, so pages stop hand-rolling their own and
 * drifting apart. Eyebrow + display heading + optional lead paragraph.
 */
const SectionHeading = ({ eyebrow, title, lead, align = "center", className = "" }) => {
  const centered = align === "center";

  return (
    <div className={`${centered ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} ${className}`}>
      {eyebrow && (
        <p className="text-moss-light text-sm font-medium tracking-[0.2em] uppercase mb-4">
          {eyebrow}
        </p>
      )}
      <h2 className="text-3xl md:text-4xl font-serif font-medium text-silver-light">
        {title}
      </h2>
      {lead && (
        <p className="mt-4 text-silver-medium leading-relaxed">{lead}</p>
      )}
    </div>
  );
};

export default SectionHeading;
